/**
 * Horizon overrides for Shopify.actions.
 * When the Kusha header is installed it owns the cart experience; otherwise
 * Horizon's native cart drawer remains the fallback.
 */

function getKushaDrawer() {
  return document.querySelector('.kusha-cart-drawer[data-cart-drawer]');
}

function disableNativeDrawerWhenKushaIsPresent() {
  if (!getKushaDrawer()) return;

  if (typeof window.clearNativeKushaCartDrawerState === 'function') {
    window.clearNativeKushaCartDrawerState();
    return;
  }

  const nativeDrawer = document.querySelector('theme-drawer#cart-drawer');
  const nativeComponent = nativeDrawer?.querySelector('cart-drawer-component');
  const pageWrapper = document.querySelector('.page-wrapper');

  nativeComponent?.removeAttribute('auto-open');
  nativeDrawer?.removeAttribute('open');
  nativeDrawer?.querySelector('dialog[open]')?.close();
  pageWrapper?.classList.remove('page-wrapper--drawer-open');

  try {
    const persistedDrawers = (sessionStorage.getItem('theme-drawer-open') || '')
      .split(',')
      .filter((drawerId) => drawerId && drawerId !== 'cart-drawer');

    if (persistedDrawers.length) {
      sessionStorage.setItem('theme-drawer-open', persistedDrawers.join(','));
    } else {
      sessionStorage.removeItem('theme-drawer-open');
    }
  } catch {
    // Storage may be unavailable in privacy-restricted previews.
  }
}

async function openPreferredCart() {
  if (getKushaDrawer()) {
    if (typeof window.refreshAndOpenKushaCartDrawer === 'function') {
      await window.refreshAndOpenKushaCartDrawer();
      return;
    }

    if (typeof window.openKushaCartDrawer === 'function') {
      window.openKushaCartDrawer();
      return;
    }
  }

  /** @type {HTMLElement & {open?: () => void} | null} */
  const drawer = document.querySelector('theme-drawer#cart-drawer');

  if (drawer?.open) {
    drawer.open();
  } else {
    window.location.href = window.Theme?.routes?.cart_url || '/cart';
  }
}

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => getKushaDrawer() ?? document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    handler: openPreferredCart,
  });

  disableNativeDrawerWhenKushaIsPresent();
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', disableNativeDrawerWhenKushaIsPresent, { once: true });
} else {
  disableNativeDrawerWhenKushaIsPresent();
}

window.addEventListener('pageshow', disableNativeDrawerWhenKushaIsPresent);
document.addEventListener('shopify:section:load', disableNativeDrawerWhenKushaIsPresent);
